import { AMPLIFY_STORE_PREFIX as PREFIX } from './constants';

export type Store = Record<string, string>;

export class AmplifyStorage implements Storage {
  private store: Store = {};
  private tenantAlias = '';
  private _changed = false;

  setTenantAlias(tenantAlias: string) {
    this.tenantAlias = tenantAlias;
  }

  get length(): number {
    return Object.keys(this.store).length;
  }
  key(index: number): string | null {
    return Object.keys(this.store)[index];
  }

  getItem(key: string): string | null {
    return this.store[this.getStoreKey(key)];
  }

  setItem(key: string, value: string): void {
    const localKey = this.getStoreKey(key);
    const p_val = this.store[localKey];
    this.store[localKey] = value;
    if (p_val !== value) {
      this._changed = true;
    }
  }

  removeItem(key: string): void {
    delete this.store[this.getStoreKey(key)];
    this._changed = true;
  }

  clear(): void {
    this.store = {};
    this._changed = true;
  }

  protected getStoreKey(key: string): string {
    if (!key.startsWith(PREFIX)) {
      return `${PREFIX}${this.tenantAlias}-${key}`;
    }

    return key;
  }

  public get isChanged(): boolean {
    return this._changed;
  }
  public syncStore(): void {
    this._changed = false;
  }

  public getStore(): Store {
    return { ...this.store };
  }

  public restore(store: Store) {
    this.clear();
    this.store = { ...store };
    this._changed = false;
  }
}
